export function CreatedByLine({ author, createdBy }) {
  if (author.id !== createdBy.id) {
    return (
      <p className="text-xs text-zinc-400">
        Created by {createdBy.name} for {author.name}
      </p>
    )
  }
  return null
}
